import React from 'react'
import SpinAndWinIcon from './SpinAndWinIcon'
import SpinAndWinModal from './SpinAndWinModal'
import { getUserSpins } from '../../../services/api/requests/Gamification'
import { useStateWithCallback } from '../../../services/hooks/useStateWithCallback'
import { useThirdPartyCookieCheck } from '../../../services/hooks/useThirdPartyCookieCheck'

const SpinAndWin = ({
  canShow,
  accessToken,
  isUserAdvanced,
  firstSpinModalOpen,
  displayProfileModal,
  setFirstSpinModalOpen,
}) => {
  const [showModal, setShowModal] = React.useState(false)
  const [showIcon, setShowIcon] = React.useState(
    canShow && isUserAdvanced === false,
  )
  const [spinData, setSpinData] = useStateWithCallback({
    numberOfChance: 0,
    url: '',
  })
  const { initLoad, getCookiesSupported } = useThirdPartyCookieCheck()

  const getSpins = async (callback = () => {}) => {
    try {
      const { data } = await getUserSpins({ accessToken })
      setSpinData(data, callback)
    } catch (error) {
      setShowModal(false)
      setShowIcon(false)
      setSpinData({
        numberOfChance: 0,
        url: '',
      })
    }
  }
  const openNewTab = url => {
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.target = '_blank'
    anchor.rel = 'noopener noreferrer'
    url && anchor.click()
  }
  const onClickIcon = () => {
    accessToken &&
      getSpins(data => {
        data.numberOfChance === 0 &&
          !isUserAdvanced &&
          displayProfileModal(true)

        if (getCookiesSupported()) {
          setShowModal(true)
          setShowIcon(data.numberOfChance === 0 && !isUserAdvanced)
        } else {
          data.numberOfChance > 0 && openNewTab(data.url)
        }
      })
  }
  const onCloseModal = () => {
    setShowModal(false)
    setShowIcon(true)
    getSpins()
  }
  const onCloseIcon = () => {
    setShowIcon(false)
  }

  React.useEffect(() => {
    initLoad()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  React.useEffect(() => {
    if (canShow) {
      getSpins(data => {
        setShowIcon(true)
        const cookiesSupported = getCookiesSupported()
        // !cookiesSupported && setShowModal(false) && openNewTab(data.url)
        setShowModal(cookiesSupported && firstSpinModalOpen)
        setFirstSpinModalOpen(false)
      })
      // setShowModal(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canShow])
  React.useEffect(() => {
    isUserAdvanced && getSpins()
    // setShowIcon(isUserAdvanced === false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAdvanced])

  // ST-7368 - [Web] Skale :: Remove Persistent Icon
  // return canShow ? (
  //   <div>
  //     <SpinAndWinIcon
  //       show={
  //         showIcon &&
  //         !(showModal && spinData.numberOfChance > 0) &&
  //         (!isUserAdvanced || spinData.numberOfChance > 0)
  //       }
  //       onClick={onClickIcon}
  //       onClose={onCloseIcon}
  //     />
  //     <SpinAndWinModal
  //       show={showModal && spinData.numberOfChance > 0}
  //       url={spinData.url}
  //       onClose={onCloseModal}
  //     />
  //   </div>
  // ) : (
  //   <></>
  // )

  return <></>
}

export default SpinAndWin
